
import { projectLicencePage, projectLicenceDelete } from "@/api/api-basic";
import piAccountNumberAdd from "./components/account-number-add.vue";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component({
  components: {
    piAccountNumberAdd
  }
})
export default class PiAccountNumber extends Vue {
  private piAccountNumberAdd: objAny = {};
  private loading = false;
  private total = 0;
  private time: object[] = [];
  private formInline: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10,
    projectPkId: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("cardClient.moduleNames"),
      key: "moduleNames",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.machineCode"),
      key: "machineCode",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.pileNumber"),
      key: "pileNumber",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.status"),
      key: "statusDesc",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.beginTime"),
      key: "beginTime",
      resizable: true,
      minWidth: 120
    },
    {
      title: i18n.t("cardClient.endTime"),
      key: "endTime",
      resizable: true,
      minWidth: 120
    },
    {
      title: i18n.t("operation"),
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];

  public goBackClick(): void {
    this.$emit("isShow", this);
    this.$emit("success");
  }

  public addNewAbout(): void {
    this.piAccountNumberAdd.open("add", this.formInline.projectPkId);
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  // 下载
  // public downloadFile(item: objAny): void {}
  // 修改
  public updRate(item: objAny): void {
    this.piAccountNumberAdd.open("upd", this.formInline.projectPkId, item);
  }
  // 删除
  async delItemRate(item: objAny): Promise<void> {
    const ret = await projectLicenceDelete({
      projectLicensePkId: item.projectLicensePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await projectLicencePage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      if (ret.data) {
        this.total = ret.total;
        this.tableList = ret.data;
      } else {
        this.total = 0;
        this.tableList = [];
      }
    }
    this.loading = false;
  }
  public open(item: objAny, type: string) {
    this.formInline.projectPkId = item.projectPkId;
    this.getTableList();
  }
  mounted() {
    this.$nextTick((): void => {
      this.piAccountNumberAdd = this.$refs["piAccountNumberAdd"];
    });
  }
}
